/** The dashboard landing page. */
export default {
    title: 'Dashboard',
    storage: {
        full: 'Storage {percent}% full: {used} of {quota}.',
        refused: 'New uploads and backups will be refused once it is full.',
    },
    shop: {
        heading: 'Shop, {month}',
        allOrders: 'All orders →',
        loadFailed: 'Shop figures could not be loaded: {error}',
        noRevenue: 'No revenue yet',
        revenueInclVat: '{revenue} incl. VAT',
        ordersThisMonth: 'Orders this month',
        toShip: 'To ship',
        toShipHint: 'Paid, not yet shipped',
        totalOrders: 'Total orders',
        totalOrdersHint: 'Since the shop opened',
        newCustomers: 'New customers',
        newCustomersHint: 'Accounts this month',
        outOfStock: 'Out of stock',
        outOfStockHint: 'Products on sale',
    },
    traffic: {
        heading: 'Last 7 days',
        fullStatistics: 'Full statistics →',
        views: 'Views',
        uniqueVisitors: 'Unique visitors',
        sessions: 'Sessions',
        avgDwell: 'Avg dwell',
        pageviews: 'Pageviews',
    },
    duration: {
        ms: '{n} ms',
        seconds: '{n} s',
        minutes: '{m}m {s}s',
    },
};
